import { PluginKey, Plugin } from 'prosemirror-state';
import { DecorationSet, Decoration } from 'prosemirror-view';
import { styleValue } from '../mark.js';

const caretColorKey = new PluginKey('caret-color');
function caretColor() {
    return new Plugin({
        key: caretColorKey,
        props: {
            decorations: (state) => {
                const { doc, selection, storedMarks } = state;
                if (!selection.empty || !storedMarks) {
                    return DecorationSet.empty;
                }
                const color = styleValue((storedMarks || []).find((m) => m.type.name === 'style'), { name: 'color', value: /^.+$/ });
                if (!color) {
                    return DecorationSet.empty;
                }
                const parentNode = selection.$anchor.parent;
                const decorations = [];
                doc.descendants((node, pos) => {
                    if (node.eq(parentNode)) {
                        decorations.push(Decoration.node(pos, pos + node.nodeSize, {
                            style: 'caret-color: ' + color
                        }));
                    }
                });
                return DecorationSet.create(doc, decorations);
            }
        }
    });
}

export { caretColor, caretColorKey };
